<span *ngIf="value.YBI" status="primary">YBI, </span>
<span *ngIf="value.Homhero" status="primary">HOMHero</span>
<span *ngIf="!value.YBI && !value.Homhero">No Integrations</span>
